"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutCharacterPropertiesColorInfo = void 0;
var LayoutCharacterPropertiesColorInfo = (function () {
    function LayoutCharacterPropertiesColorInfo(textColor, foregroundColor, strikeoutColor, underlineColor) {
        this.textColor = textColor;
        this.foregroundColor = foregroundColor;
        this.strikeoutColor = strikeoutColor;
        this.underlineColor = underlineColor;
    }
    LayoutCharacterPropertiesColorInfo.prototype.equals = function (obj) {
        return obj &&
            this.textColor == obj.textColor &&
            this.foregroundColor == obj.foregroundColor &&
            this.strikeoutColor == obj.strikeoutColor &&
            this.underlineColor == obj.underlineColor;
    };
    LayoutCharacterPropertiesColorInfo.prototype.clone = function () {
        return new LayoutCharacterPropertiesColorInfo(this.textColor, this.foregroundColor, this.strikeoutColor, this.underlineColor);
    };
    return LayoutCharacterPropertiesColorInfo;
}());
exports.LayoutCharacterPropertiesColorInfo = LayoutCharacterPropertiesColorInfo;
